import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

export function ViewEvent({ eventDefID }) {
  return (
    <Button color="primary" href={`/events/schema/${eventDefID}`}>
      View Event
    </Button>
  );
}

ViewEvent.propTypes = {
  eventDefID: PropTypes.string.isRequired,
};

export function DefineEvent({ type, typeSpecificProperty }) {
  return (
    <Button
      color="primary"
      href={`/events/schema/new?${new URLSearchParams({
        type,
        typeSpecificProperty,
      }).toString()}`}
    >
      Create Event
    </Button>
  );
}

DefineEvent.propTypes = {
  type: PropTypes.string.isRequired,
  typeSpecificProperty: PropTypes.string.isRequired,
};
